/* eslint-disable */
import React, { useState, useEffect, useCallback } from 'react';
import { Box, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import MaterialTable from 'material-table';
import PopupState, { bindPopover, bindHover } from 'material-ui-popup-state';
import HoverPopover from 'material-ui-popup-state/HoverPopover';
import Loader from '../../../../components/Loader/Loader';
import InfoPopoverCommentsWrapper from '../../../../components/InfoPopoverCommentsWrapper';
import moment from 'moment';
// Your component code...

/* CSS */
import useStyles from '../../Main.style';
import InfoPopover from '../../../../components/InfoPopover/InfoPopover';

const QbFieldsByCountry = ({
  reportByCell,
  reportArr,
  myCountryInvoiceArray,
  myProfitRevenue,
  financialPerformanceCountryByYear,
  dashboardComments,
  dashboardSectionText,
}) => {
  const classes = useStyles();
  const [pastDueInvoicesObject, setPastDueInvoicesObject] = useState([]);
  const [isLoaded] = useState(true);
  const [operatingIncomeObject, setOperatingIncomeObject] = useState([]);
  const [incomeBeforeTaxesObject, setIncomeBeforeTaxesObject] = useState([]);

  const fillOperatingIncome = async ({ reportByCell }) => {
    // Initialize sum of operatingIncome
    let sumOfOperatingIncome = 0;

    // Calculate sum of operatingIncome
    reportByCell.forEach((obj) => {
      if (obj?.reportPeriod.split('-')[0] == moment().year()) {
        sumOfOperatingIncome += parseFloat(obj?.operatingIncome || 0); // Adding || 0 to handle null or undefined
      }
    });
    setOperatingIncomeObject(sumOfOperatingIncome?.toFixed(2));
  };

  const fillIncomeBeforeTaxes = async ({ reportByCell }) => {
    let sumOfIncomeBeforeTaxes = 0;
    reportByCell.forEach((obj) => {
      if (obj?.reportPeriod.split('-')[0] == moment().year()) {
        sumOfIncomeBeforeTaxes += parseFloat(obj?.incomeBeforeTaxes || 0); // Adding || 0 to handle null or undefined
      }
    });
    //Ranking logic
    setIncomeBeforeTaxesObject(sumOfIncomeBeforeTaxes?.toFixed(2));
  };

  const findColumnObject = useCallback(async (obj, searchText, parentObj = null) => {
    if (typeof obj === 'object') {
      if (Array.isArray(obj)) {
        const results = await Promise.all(
          obj.map((item) => findColumnObject(item, searchText, obj)),
        );
        return results.find((result) => result !== null);
      }
      const keys = Object.keys(obj);
      const results = await Promise.all(
        keys.map((key) => findColumnObject(obj[key], searchText, obj)),
      );
      const foundResult = results.find((result) => result !== null);
      if (foundResult) {
        return foundResult;
      }
      const foundKey = keys.find(
        (key) =>
          typeof obj[key] === 'string' && obj[key].toLowerCase() === searchText.toLowerCase(),
      );
      if (foundKey) {
        return { object: obj, parent: parentObj };
      }
    }
    return null;
  }, []);

  const findObjectBySearchText = useCallback(async (obj, searchText) => {
    if (typeof obj === 'object') {
      if (Array.isArray(obj)) {
        const results = await Promise.all(
          obj.map((item) => findObjectBySearchText(item, searchText)),
        );
        return results.find((result) => result !== null);
      }
      const keys = Object.keys(obj);
      const results = await Promise.all(
        keys.map((key) => findObjectBySearchText(obj[key], searchText)),
      );
      const foundResult = results.find((result) => result !== null);
      if (foundResult) {
        return foundResult;
      }
      const foundKey = keys.find(
        (key) =>
          typeof obj[key] === 'string' &&
          obj[key].toLowerCase().indexOf(searchText.toLowerCase()) !== -1,
      );
      if (foundKey) {
        return { object: obj };
      }
    }
    return null;
  }, []);

  const fillPastDueTotals = useCallback(
    async (reportObj) => {
      const pastDueColumns = await findColumnObject(reportObj?.reportResult, 'Customer');

      let requiredColumnIndex31andOver = 0;
      let requiredColumnIndexCurrent = 0;
      let requiredColumnIndex1to30 = 0;
      let requiredColumnIndexOverallOutstanding = 0;

      pastDueColumns?.parent.forEach((c, i) => {
        if (c?.ColTitle?.toLowerCase() === '31 and over') {
          requiredColumnIndex31andOver = i;
        } else if (c?.ColTitle?.toLowerCase() === 'current') {
          requiredColumnIndexCurrent = i;
        } else if (c?.ColTitle?.toLowerCase() === '1 - 30') {
          requiredColumnIndex1to30 = i;
        } else if (c?.ColTitle?.toLowerCase() === 'total') {
          requiredColumnIndexOverallOutstanding = i;
        }
      });

      const pastDueInvTotalYtd = await findObjectBySearchText(
        reportObj?.reportResult,
        'GrandTotal',
      );
      const pastDueAmt =
        pastDueInvTotalYtd?.object?.Summary?.ColData[requiredColumnIndexOverallOutstanding];
      const currentAmt = pastDueInvTotalYtd?.object?.Summary?.ColData[requiredColumnIndexCurrent];
      const oneToThirtyAmt = pastDueInvTotalYtd?.object?.Summary?.ColData[requiredColumnIndex1to30];
      const thirtyAndOverAmt =
        pastDueInvTotalYtd?.object?.Summary?.ColData[requiredColumnIndex31andOver];

      setPastDueInvoicesObject((prevState) => [
        ...prevState,
        {
          pastDueTotal: pastDueAmt?.value || 0,
          country: reportObj?.country,
          current: currentAmt?.value || 0,
          oneToThirty: oneToThirtyAmt?.value || 0,
          thirtyAndOver: thirtyAndOverAmt?.value || 0,
        },
      ]);
    },
    [findColumnObject, findObjectBySearchText],
  );

  const format1CountryData = (data, styles) => {
    if (!data) {
      return 0;
    }
    if (data.includes('(')) {
      return <Typography className={styles.TableTextRed}>{data}</Typography>;
    }
    return data;
  };

  const format2CountryData = (data, styles) => {
    if (!data || data?.length === 0) {
      return '$0';
    }
    const cleanedData = /[$,]/.test(data) ? data.replace(/[$,]/g, '') : data;
    const numberData = Number(cleanedData);
    if (numberData < 0) {
      // Format the number as a currency and apply custom formatting for negative values
      const formattedValue = `(-$${Math.abs(numberData).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })})`;
      return <Typography className={styles.TableTextRed}>{formattedValue}</Typography>;
    }
    // Format positive numbers normally
    return `$${numberData.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  useEffect(() => {
    fillPastDueTotals(reportArr);
  }, [fillPastDueTotals, reportArr]);

  useEffect(() => {
    fillOperatingIncome({ reportByCell });
  }, []);

  useEffect(() => {
    fillIncomeBeforeTaxes({ reportByCell });
  }, []);

  return (
    <>
      <If condition={!isLoaded}>
        <Loader />
      </If>
      <If condition={isLoaded}>
        {/* PROFIT COMPONENT */}
        <Box className={classes.innercontentWhite} height="100%">
          <Box display="flex" justifyContent="space-between">
            <Typography variant="h5" noWrap>
              INVOICING - Accounting (QuickBooks & Digital Contpaqi)
            </Typography>
            <InfoPopover />
          </Box>
          {console.log(myCountryInvoiceArray[7]?.usa, 32923)}
          <Box mt={1} className={classes.TableUIV2}>
            <MaterialTable
              style={{ boxShadow: 'none' }}
              options={{
                toolbar: false,
                draggable: false,
                paging: false,
                sorting: true,
                pageSize: 20,
                pageSizeOptions: [10, 20, 50, 100],
                showTextRowsSelected: false,
                toolbarButtonAlignment: 'right',
                showFirstLastPageButtons: false,
                actionsColumnIndex: -100,
                emptyRowsWhenPaging: false,
              }}
              localization={{
                pagination: {
                  labelRowsSelect: 'Rows',
                  labelRowsPerPage: 'Rows Per Page',
                },
              }}
              title="Invoicing"
              columns={[
                {
                  title: `${new Date().getFullYear()} YTD`,
                  field: 'ytd',
                },
                {
                  title: 'USA',
                  field: 'usa',
                },
                {
                  title: 'Mexico',
                  field: 'mexico',
                },
                {
                  title: 'Chile',
                  field: 'chile',
                },
                {
                  title: 'Peru',
                  field: 'peru',
                },
              ]}
              data={[
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Revenue"
                      title={dashboardSectionText}
                    />
                  ),
                  usa: format2CountryData(financialPerformanceCountryByYear?.us?.revenue, classes),
                  mexico: format2CountryData(
                    financialPerformanceCountryByYear?.mx?.revenue,
                    classes,
                  ),
                  chile: format2CountryData(
                    financialPerformanceCountryByYear?.cl?.revenue,
                    classes,
                  ),
                  peru: format2CountryData(financialPerformanceCountryByYear?.pr?.revenue, classes),
                },
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Revenue Target"
                      title={dashboardSectionText}
                    />
                  ),
                  usa: format2CountryData(myCountryInvoiceArray[6]?.usa * -18998, classes),
                  mexico: format2CountryData(myCountryInvoiceArray[6]?.mexico, classes),
                  chile: format2CountryData(myCountryInvoiceArray[6]?.chile, classes),
                  peru: format2CountryData(myCountryInvoiceArray[6]?.peru, classes),
                },
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Gross Profit"
                      title={dashboardSectionText}
                    />
                  ),
                  usa: format2CountryData(
                    financialPerformanceCountryByYear?.us?.grossProfit,
                    classes,
                  ),
                  mexico: format2CountryData(
                    financialPerformanceCountryByYear?.mx?.grossProfit,
                    classes,
                  ),
                  chile: format2CountryData(
                    financialPerformanceCountryByYear?.cl?.grossProfit,
                    classes,
                  ),
                  peru: format2CountryData(
                    financialPerformanceCountryByYear?.pr?.grossProfit,
                    classes,
                  ),
                  // usa: format1CountryData(myCountryInvoiceArray[5]?.usa, classes),
                  // mexico: format1CountryData(myCountryInvoiceArray[5]?.mexico, classes),
                  // chile: format1CountryData(myCountryInvoiceArray[5]?.chile, classes),
                  // peru: format1CountryData(myCountryInvoiceArray[5]?.peru, classes),
                },
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Gross Profit Target"
                      title={dashboardSectionText}
                    />
                  ),
                  usa: format2CountryData(myCountryInvoiceArray[7]?.usa, classes),
                  mexico: format2CountryData(myCountryInvoiceArray[7]?.mexico, classes),
                  chile: format2CountryData(myCountryInvoiceArray[7]?.chile, classes),
                  peru: format2CountryData(myCountryInvoiceArray[7]?.peru, classes),
                },
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Operating Income"
                      title={dashboardSectionText}
                    />
                  ),
                  usa: format2CountryData(
                    financialPerformanceCountryByYear?.us?.operatingIncome || operatingIncomeObject,
                    classes,
                  ),
                  mexico: format2CountryData(
                    financialPerformanceCountryByYear?.mx?.operatingIncome,
                    classes,
                  ),
                  chile: format2CountryData(
                    financialPerformanceCountryByYear?.cl?.operatingIncome,
                    classes,
                  ),
                  peru: format2CountryData(
                    financialPerformanceCountryByYear?.pe?.operatingIncome,
                    classes,
                  ),
                },
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Income Before Taxes"
                      title={dashboardSectionText}
                    />
                  ),
                  usa: format2CountryData(
                    financialPerformanceCountryByYear?.us?.incomeBeforeTaxes ||
                      incomeBeforeTaxesObject,
                    classes,
                  ),
                  mexico: format2CountryData(
                    financialPerformanceCountryByYear?.mx?.incomeBeforeTaxes,
                    classes,
                  ),
                  chile: format2CountryData(
                    financialPerformanceCountryByYear?.cl?.incomeBeforeTaxes,
                    classes,
                  ),
                  peru: format2CountryData(
                    financialPerformanceCountryByYear?.pe?.incomeBeforeTaxes,
                    classes,
                  ),
                },
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Current (Not Yet Due)"
                      title={dashboardSectionText}
                    />
                  ),
                  usa: format2CountryData(
                    pastDueInvoicesObject.find((c) => c?.country?.shortName.toLowerCase() === 'us')
                      ?.current || 0,
                  ),
                  mexico: '$0',
                  chile: '$0',
                  peru: '$0',
                },
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="1 - 30 Days Past Due Amount"
                      title={dashboardSectionText}
                    />
                  ),
                  usa: format2CountryData(
                    pastDueInvoicesObject.find((c) => c?.country?.shortName.toLowerCase() === 'us')
                      ?.oneToThirty || 0,
                  ),
                  mexico: '$0',
                  chile: '$0',
                  peru: '$0',
                },
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="> 31+ Days Past Due Amount"
                      title={dashboardSectionText}
                    />
                  ),
                  usa: format2CountryData(
                    pastDueInvoicesObject.find((c) => c?.country?.shortName.toLowerCase() === 'us')
                      ?.thirtyAndOver || 0,
                  ),
                  mexico: '$0',
                  chile: '$0',
                  peru: '$0',
                },
                {
                  ytd: (
                    <InfoPopoverCommentsWrapper
                      dashboardComments={dashboardComments}
                      section="Overall Outstanding"
                      title={dashboardSectionText}
                    />
                  ),
                  usa: format2CountryData(
                    pastDueInvoicesObject.find((c) => c?.country?.shortName.toLowerCase() === 'us')
                      ?.pastDueTotal || 0,
                  ),
                  mexico: '$0',
                  chile: '$0',
                  peru: '$0',
                },
              ]}
            />
          </Box>
        </Box>
      </If>
    </>
  );
};

QbFieldsByCountry.propTypes = {
  reportByCell: PropTypes.arrayOf(PropTypes.object).isRequired,
  reportArr: PropTypes.arrayOf(PropTypes.object).isRequired,
  myCountryInvoiceArray: PropTypes.arrayOf(PropTypes.object).isRequired,
  myProfitRevenue: PropTypes.number.isRequired,
  financialPerformanceCountryByYear: PropTypes.shape({
    us: PropTypes.shape({
      operatingIncome: PropTypes.number,
      incomeBeforeTaxes: PropTypes.number,
    }).isRequired,
  }).isRequired,
};
export default QbFieldsByCountry;
